import TagManager from "react-gtm-module";

const gtm = (): void =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-return
  TagManager.initialize({
    gtmId: process.env.NEXT_PUBLIC_GTM_ID,
  });

export default gtm;
